export default {
  "content": "<path clip-rule=\"evenodd\" d=\"M2 8a6 6 0 1112 0A6 6 0 012 8zm6-8a8 8 0 100 16A8 8 0 008 0zm1 5a1 1 0 00-2 0v3a1 1 0 002 0zm-1 7a1 1 0 100-2 1 1 0 000 2z\" fill=\"#ff00cb\" fill-rule=\"evenodd\"/>",
  "attrs": {
    "viewBox": "0 0 16 16",
    "fill": "none",
    "height": "16",
    "width": "16",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};